<template lang="pug">
page(
    main-title="Партнёрский кабинет",
    main-description="Здесь информация о магазинах, зарегистрированных по Вашим промо"
)   
    .panel
        .panel-body
            .row(v-if="!companies.length && !promos.length")
                .col-md-12(v-if="loaded") Пока тут пусто...
                .col-md-12(v-else) Секундочку...

            .row.margin-bottom-20(v-if="promos.length")
                .col-md-12
                    .row
                        .col-md-12.margin-bottom-10 Действующие <b>промо</b>:
                    .row(v-for="promo in promos")
                        .col-md-12(v-html="promo")

                    .row.margin-top-20(v-if="!companies.length")
                        .col-md-12 По вашим <b>промо</b> ещё не было регистраций, 
                            | с нетерпением их <b>ждём</b>!

            .row(v-if="companies.length") 
                .col-md-12
                    .row
                        .col-md-12.margin-bottom-10 Зарегистрированные <b>магазины</b> 
                            | (может быть несколько доменов для одного аккаунта):
                    .row(v-for="company in companies")
                        .col-md-12 
                            template(v-for="(domain, index) in company.domains")
                                a(:href="domain") {{ domain }}
                                span(v-if="index != company.domains.length - 1") , 
                            span  – <b>{{ company.paid_count }}</b> 
                                | {{ getPaidCountPlural(company.paid_count) }}
    
</template>

<script>
import ajaxRequest from '@/utils/request';

export default {
    name: 'PartnerShops',
    created() {
        ajaxRequest({
            url: '/partners/',
            success: ({data: {companies, promos}}) => {
                this.companies = companies;
                this.promos = promos;
                this.loaded = true;
            }
        });
    },
    methods: {
        getPaidCountPlural(count) {
            const r = count % 10;
            return r == 1 ? 'платёж' : (r > 1 && r < 5 ? 'платежа' : 'платежей');
        }
    },
    data() {
        return {
            loaded: false,
            companies: [],
            promos: []
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/partners/PartnerShops.vue